
const m = window.require("@ember/routing");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
